// extracted by mini-css-extract-plugin
export default {"about":"method_about__oS972","title":"method_title__+GIx4","text":"method_text__CupHV","line":"method_line__VWjxT"};